import { FC } from 'react';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { CustomSpinner } from '@yakoffice/custom-spinner';
import { GameVersionForm } from './gameVersionForm';
import { Card } from 'react-bootstrap';
import { useGameVersion } from '../../../loaders/useGameVersion';

export interface GameVersionCardProps {
    updateCallbackTrigger: (clearActiveGameVersion?: boolean) => void;
}

export const NewGameVersionCard: FC<GameVersionCardProps> = observer((props: GameVersionCardProps) => {

    const gameVersionResult = useGameVersion();

    return (
        !gameVersionResult.isLoaded
            ? <CustomSpinner spinnerText="Loading game version..." />
            : gameVersionResult.gameVersion &&
            <Card key={gameVersionResult.gameVersion.id} className={'m3Card'}>
                <Card.Body className={"cardBody"}>
                    <GameVersionForm gameVersion={gameVersionResult.gameVersion}
                                     updateCallbackTrigger={props.updateCallbackTrigger} />
                </Card.Body>
            </Card>
    );
});
